import { DomainLayout } from "@/components/layouts/DomainLayout";
import { InstallmentsView } from "../views/InstallmentsView";

export const InstallmentsPage = () => {
  return (
    <DomainLayout>
      <InstallmentsView />
    </DomainLayout>
  );
};
